<template>
  <div class="row role-display">
    <div
      v-for="role in roles"
      :key="role.id_role"
      class="col role"
      v-bind:class="{ active: roleSelected === role.id_role }"
      @click="roleSelected = role.id_role"
    >
      {{ role.role_display }}
    </div>
  </div>
</template>
<script>
import { onMounted, onUpdated, ref } from "vue";
export default {
  props: ["roles", "userInfos"],
  emits: ["changerole"],
  setup(props, { emit }) {
    const roleSelected = ref();

    onMounted(() => {
      roleSelected.value = props.userInfos ?? 3; // ? 3 -> restreint
    });

    onUpdated(() => {
        emit("changerole", roleSelected.value ?? props.userInfos ?? 3);
    });

    return {
      roleSelected,
    };
  },
};
</script>

<style lang="scss" scoped>
.role-display {
  margin-left: 0;
  margin-right: 0;
  gap: 1rem;
  .active {
    background-color: var(--mainBlue);
    color: white;
  }
  .role {
    border-radius: 3px;
    padding: 0.5rem;
    transition: all 0.2s ease-out;
    // box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border: 1px solid #e9e9e9;
    cursor: pointer;
    z-index: 1;
    overflow: hidden;
  }
  .role::after {
    content: " ?";
    display: inline-block;
    transform: translate(-0.5rem);
    opacity: 0;
    transition: all 0.2s ease-out;
  }
  .role:hover::after {
    opacity: 100;
    transform: translate(0.3rem) scale(1.1);
  }
}
</style>